import React, { useEffect, useState } from 'react'
import AttendanceDaysShowCard from '../../Components/AttendanceDaysShowCard'
import Table from '../../Components/Table'
import { useLocation } from 'react-router-dom';
import qs from "query-string";

const header = [
  { field: "Date" },
  { field: "Status" },
  { field: "Clock In" },
  { field: "Clock Out" },
  { field: "Total" },
  { field: "Others" },
];

const PersonData = [
  {
    id:1,
    date: '20-09-2024',
    day: 'Friday',
    status: 'Absent',
    clockTimes: [],
    total: '-',
    location: ''
  },
  {
    id:2,
    date: '19-09-2024',
    day: 'Thursday',
    status: 'Present',
    clockTimes: [
      { clockIn: '10:10 am', clockOut: '01:16 pm', location: 'Ahmedabad', workType: 'Office' },
      { clockIn: '01:57 pm', clockOut: '-', location: 'Ahmedabad', workType: 'Home' }
    ],
    total: '9h 38m',
    location: 'Ahmedabad (office)'
  },
  {
    id:3,
    date: '18-09-2024',
    day: 'Wednesday',
    status: 'Present',
    clockTimes: [
      { clockIn: '10:21 am', clockOut: '02:22 pm', location: 'Ahmedabad', workType: 'Office' },
      { clockIn: '03:01 pm', clockOut: '07:00 pm', location: 'Ahmedabad', workType: 'Field' }
    ],
    total: '7h 59m',
    location: 'Ahmedabad (office)'
  },
];


function AttendanceByMember() {
  const [viewChange, setViewChange] = useState("Table");
  const [inData, setInData] = useState([]);
  const [checked, setChecked] = useState(false);
  const [exportLoading, setExportrLoading] = useState(false);
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [params, setParams] = useState({});
  const [selectedId, setSelectedId] = useState([]);
  const [selectFilters, setSelectedFilters] = useState({
    tasks: [],
    Data: "",
    Project: [],
    DueDate: ""
  });

  const location = useLocation();
  const data = location.state;
  let footer = true;
  let count = 5;

  useEffect(() => {
    (async () => {
      try {
        setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
        setInData(
          PersonData.map((item) => {
            return {
              "Date": {
                value: item.date,
                value2: item.day,
                type: "date",
              },
              "Status": {
                value: item.status,
                type: 'attandancestatus'
              },
              "Clock In":{
                value:item.clockTimes,
                type:"clockin"
              },
              "Clock Out":{
                value:item.clockTimes,
                type:"clockout"
              },
              "Total": {
                value: item.total,
                type: "text"
              },
              "Others": {
                value2: "/attendance/details",
                type: "action",
              }
            }
          }
          )
        )
      } catch (error) {
        console.error("Error fetching:", error);
      }
    })();
  }, [location.search]);


  const handleChange = (e) => {
    if (e[1] == "headerAll" && e[0] === true) {
      setTotalSelectedIds([...e[2]]);
    } else if (e[0] === true && e[1] !== "headerAll") {
      setTotalSelectedIds([...totalSelectedIds, e[1]]);
    } else if (e[1] == "headerAll" && e[0] === false) {
      setTotalSelectedIds([]);
    } else {
      let filterdId = totalSelectedIds.filter((item) => {
        return item != e[1];
      });
      setTotalSelectedIds(filterdId);
    }
  };

  const handleClick = async (totalSelectedIds, type) => {
    let ids = totalSelectedIds.map((id) => parseFloat(id));

    try {
      // Deletion Function 
      if (type === "delete") {
        setDeleteLoading(true);
        // Wait for the deletion to complete before moving on
        await props.deleteInvoices(ids);
        setChecked(false);
        setTotalSelectedIds([]);
      } else if (type === "export") {
        setExportrLoading(true);
        await handlePdfDownload(ids);
        toast.success("Exported Successfully");
      }
    } catch (error) {
      console.error(error);
    } finally {
      await fetchData();
      // if (!props.loading && props.success) {
      // }
      setDeleteLoading(false);
    }
  };

  useEffect(() => {
    if (totalSelectedIds.length > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [totalSelectedIds]);

  return (
    <div>
      <div className='row'>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard title="Working Days" qty={10}/>
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard  title="Days Present" qty={20}/>
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard  title='Late' qty={2}/>
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard  title="Half Days" qty={5}/>
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard  title="Absent" qty={4}/>
        </div>
        <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12">
          <AttendanceDaysShowCard  title="Holiday" qty={8}/>
        </div>
        <div className="col-lg-12 col-md-12 ">

          <Table
            header={header}
            data={inData}
            footer={footer}
            count={count}
            checked={checked}
            records={1}
            showIsView={true}
            // showIsDelete={true}
            // showIsDownload={true}
            // showIsProgressChart={true}
            // showIsReject={true}
            // showIsTimesheet={true}
            // showIsEdit={true}
            // showIsApprove={true}
            handleChange={handleChange}
            totalSelectedIds={totalSelectedIds}
            defaultParams={params}
            selectedId={selectedId}
          />

        </div>
      </div>
    </div>
  )
}

export default AttendanceByMember